import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRedbubbleComponent } from './simple-icons-redbubble.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRedbubbleComponent ],
    exports:      [ SimpleIconsRedbubbleComponent ],
    bootstrap:    []
})
export class SimpleIconsRedbubbleModule {}
